var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"game-description",on:{"click":_vm.expand}},[_c('h3',[_vm._v("Game description")]),_vm._v(" "),_c('p',{class:{ collapsed: _vm.collapsed }},[_vm._v("\n    "+_vm._s(_vm.game.summary)+"\n  ")]),_vm._v(" "),(_vm.collapsed)?_c('a',{staticClass:"read-more"},[_vm._v("Read more")]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-86efd852","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GameDetail/GameDescription.vue
// module id = null
// module chunks = 